export default __webpack_public_path__ + "static/media/Home.9e1e389d.svg";